@let errorId = safeId() + '-errors';

<div
  class="select"
  [attr.data-error]="hasErrors()"
  [attr.data-testid]="`field-${safeId()}`">
  <label
    class="label"
    [for]="safeId()">
    {{ label() }}
    <ng-content />
  </label>
  <ng-select
    [popover]="true"
    [items]="options() ?? []"
    bindLabel="label"
    bindValue="value"
    [placeholder]="placeholder() ?? ''"
    [clearable]="clearable() || nullable()"
    [searchable]="search()"
    [readonly]="readOnly()"
    [loading]="loading() !== false"
    [required]="required()"
    [ngModel]="selectValue()"
    [ngModelOptions]="{ standalone: true }"
    [labelForId]="safeId()"
    [inputAttrs]="{
      'data-testid': `field-input-${safeId()}`,
      'aria-invalid': hasErrors() ? 'true' : 'false',
      'aria-required': required() ? 'true' : 'false',
      'aria-describedby': hasErrors() ? errorId : '',
    }"
    [attr.name]="name()"
    [disabled]="isDisabled()"
    (ngModelChange)="onInputChanged($event)"
    (focus)="onFocus($event)"
    (blur)="onBlur($event)"
    (clear)="clear.emit()">
    <ng-template ng-clearbutton-tmp>
      <evc-button
        class="clear-button"
        nativeType="button"
        label="Clear"
        icon="close"
        frame="none"
        (mousedown)="$event.stopPropagation(); $event.preventDefault()" />
    </ng-template>
    @if (optionTemplate(); as template) {
      <ng-template
        ng-option-tmp
        let-item="item">
        <ng-container
          [ngTemplateOutlet]="template"
          [ngTemplateOutletContext]="{ $implicit: item }" />
      </ng-template>
    }
    @if (labelTemplate(); as template) {
      <ng-template
        ng-label-tmp
        let-item="item">
        <ng-container
          [ngTemplateOutlet]="template"
          [ngTemplateOutletContext]="{ $implicit: item }" />
      </ng-template>
    }
  </ng-select>
  @if (hasErrors()) {
    <div
      class="errors"
      [id]="errorId"
      aria-live="polite">
      <evc-icon
        icon="alert-fill"
        size="xs" />
      @if (errorText() !== '') {
        <p>{{ errorText() }}</p>
      } @else {
        @for (error of controlDir?.errors | keyvalue; track error.key) {
          <p>{{ error.value.message }}</p>
        }
      }
    </div>
  }
</div>
